<a (click)="backtoTheList()">
    <p>back to the list</p>
</a>
<div *ngIf="templateForm" class="main-box">
    <div class="main-container">
        <h2 class="global-title">
            Edit {{selectedTemplate.name}}
        </h2>
        <p-button label="Submit" (onClick)="updateTemplate()"></p-button>
        <table [formGroup]="templateForm">
            <tr>
                <td>
                    Template name*
                </td>
                <td>
                    <input pInputText placeholder="Name" type="text" formControlName="name">
                </td>
            </tr>
            <tr>
                <td>
                    Content
                </td>
                <td>
                    <textarea #textArea class="raw-editor" formControlName="body"></textarea>
                </td>
            </tr>
        </table>
    </div>
    <div>
        <!-- <div *ngFor="let field of pdfDocumentService.availableFields" (click)="insertStrToTextArea(field.value)"
            class="custom-fields">
            {{field.label}}
        </div> -->
    </div>
</div>